import * as React from 'react';
import eaiws = egr.wcf.eaiws;
import { LayoutType } from '../../../constants/LayoutConstants';
import { AppConfigurationStore } from '../../../stores/AppConfigurationStore';
import { CenteredImage } from '../../CenteredImage';
import { CatalogLabel } from './CatalogLabel';
import { LongButton } from '../../LongButton';
import { CatalogActions } from '../../../actions/CatalogActions';
import { CenteredText } from '../../CenteredText';
import { CatalogStore } from '../../../stores/CatalogStore';

interface CatalogItemProps extends React.Props<CatalogItem> {
    anchor: string | null;
    catalog: eaiws.catalog.CatalogItem;
    catalogItem: eaiws.catalog.CatalogItem;
    clickHandler: (item: eaiws.catalog.CatalogItem) => void;
    addSpacer: boolean;
    layoutType: LayoutType;
}

export class CatalogItem extends React.Component<CatalogItemProps, {}> {
    public render(): JSX.Element | null {
        const catalogPath: Array<eaiws.catalog.CatalogItem> = CatalogStore.getState().catalogPath;
        let catalogName: string = '';
        if (catalogPath[1] != null) {
            catalogName = catalogPath[1].label;
        } else if (this.props.catalog) {
            catalogName = this.props.catalog.label;
        }

        if (!AppConfigurationStore.getState().inApp) {
            let label: string = this.props.catalogItem.label;
            if (label == null || label === '') {
                label = this.props.catalogItem.name;
            }
            let tType: string = 'itemtype-catalog';
            if (this.props.catalog) {
                switch (this.props.catalogItem.type) {
                    case 'Article':
                    case 'Container':
                        tType = 'itemtype-article';
                        break;
                    default:
                        tType = 'itemtype-folder';
                        break;
                }
            }
            const catalogTile: boolean = tType === 'itemtype-catalog';
            return (
                <div
                    className={'catalog-item-container' + (catalogTile ? ' catalog-tile' : '')}
                    onClick={this.onClick}
                    id={this.props.anchor ? this.props.anchor + '-catalogitem' : ''}
                >
                    {this.props.addSpacer ? <div className="catalog-list-spacer"/> : null}
                    <div className={'catalog-item ' + tType}>
                        {this.getImageElement()}
                        <CatalogLabel catalog={this.props.catalog} catalogName={catalogName} label={label}/>
                    </div>
                    <CatalogLabel catalog={this.props.catalog} catalogName={catalogName} label={label}/>
                </div>
            );
        }
        switch (this.props.catalogItem.type) {
            case 'Container':
            case 'Article':
                return (
                    <LongButton
                        className="article-button short-border"
                        onClick={() => {CatalogActions.enterCatalogItem(this.props.catalogItem); }}
                        id={this.props.anchor ? this.props.anchor + '-catalogitem' : ''}
                    >
                        <CenteredText className="" maxHeight="100%" horizontalAlign="left" verticalAlign="top">
                            {this.props.catalog ? <div className="long-button-header">{catalogName}</div> : null}
                            <div className="long-button-text">
                                {this.props.catalogItem.label ? this.props.catalogItem.label : this.props.catalogItem.name}
                            </div>
                        </CenteredText>
                        {this.getImageElement()}
                    </LongButton>
                );
            case 'CatalogView':
            case 'Folder':
            case 'Information':
                const labelString: string = this.props.catalogItem.label ? this.props.catalogItem.label : this.props.catalogItem.name;
                let labelElement: JSX.Element = <div className="long-button-text">{labelString}</div>;
                if (labelString.split(' ').length > 0 && labelString.split(' ')[0].length >= 19) {
                    labelElement = <div className="long-button-text long-button-text-singleline">{labelString}</div>;
                }
                return (
                    <LongButton
                        arrow={true}
                        shortBorder={true}
                        className="middle-size right-image folder-button"
                        onClick={() => {CatalogActions.enterCatalogItem(this.props.catalogItem); }}
                        id={this.props.anchor ? this.props.anchor + '-catalogitem' : ''}
                    >
                        {labelElement}
                        {this.getImageElement()}
                    </LongButton>
                );
            default:
                return null;
        }
    }

    protected getImageElement = (): JSX.Element => {
        if (AppConfigurationStore.getState().inApp) {
            if (this.props.catalogItem.icon != null && this.props.catalogItem.icon !== '') {
                return <CenteredImage className="button-image" src={this.props.catalogItem.icon} />;
            }
            return <div className="button-image dummy-image"/>;
        }
        if (this.props.catalogItem.icon != null && this.props.catalogItem.icon !== '') {
            return <div className="catalog-item-image"><CenteredImage className="" src={this.props.catalogItem.icon} /></div>;
        }
        return <div className="catalog-item-image dummy-image"/>;
    };

    protected onClick = (): void => {
        if (this.props.clickHandler != null) {
            this.props.clickHandler(this.props.catalogItem);
        }
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/catalog/CatalogItem.tsx